import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";
import { Guid } from 'guid-typescript';

@Injectable()
export class LogService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('Log');
	}

	forWholeOrder(id: System.Guid): Observable<TooBig4Car.Logic.IHistoryDisplay[]> {
		return this.myBaseService.loadAll(this.url +'/'+ (id ??'') + '/WholeLog');
	}
	
}

